import { AppIcon, RawSVG } from 'core/components/icons/icon.type';

export const iconAngleDown: AppIcon = {
  svgData: '<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.17 10.47a.75.75 0 0 1 1.06 0l2.763 2.762 2.762-2.762a.75.75 0 1 1 1.061 1.06l-3.293 3.293a.75.75 0 0 1-1.06 0L8.17 11.53a.75.75 0 0 1 0-1.06Z" fill="currentColor"/></svg>' as RawSVG,
  name: 'angle-down',
};
